import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=7e6f1c20&"
var script = {}
import style0 from "./Authentication.vue?vue&type=style&index=0&id=7e6f1c20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports